import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtils } from '@eti/utils';
import { Radio, RadioGroup } from '@etg/wings';
import { getOptions } from '../utils/seatingPreference';
import { SEATING_PREFERENCE_OPTIONS, SEATING_PREFERENCE_VALUES } from '../utils/constants';
import { screenReaderOnly } from '../../common/utils/styles';
import SegmentPanel from './SegmentPanel';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const radioStyles = css`
  align-items: center;
  border: 1px solid ${etiColors.grayScale[6]};
  border-radius: 0.188rem;
  display: flex;
  height: 2.625rem;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  width: 100%;

  &:not(:last-child) {
    &.radio_option {
      margin-bottom: 0.5rem;
    }
  }

  .etiCustomRadio {
    position: relative;
  }

  @media ${mediaQueries.large.up} {
    padding-left: 1rem;
  }

  html[dir='rtl'] & {
    padding-left: 1rem;
  }
`;
const priceStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0 0 0 auto;
  text-align: right;
  width: 30%;

  html[dir='rtl'] & {
    margin: 0.25rem auto 0 0;
    text-align: left;
  }
`;
const labelStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  padding: 0 0.625rem;
`;
const SeatingLightOrBeside = _ref => {
  var _selectedSeatPreferen, _selectedSeatPreferen2, _price$price$value, _price$price, _price$markup$value, _price$markup;
  let {
    activeSegment,
    typename: type = SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE,
    price,
    onChange,
    selectedSeatPreference,
    activeTraveler
  } = _ref;
  const {
    t
  } = useTranslation();
  const options = getOptions(type);
  const selectedPreference = (_selectedSeatPreferen = selectedSeatPreference === null || selectedSeatPreference === void 0 || (_selectedSeatPreferen2 = selectedSeatPreference[0]) === null || _selectedSeatPreferen2 === void 0 ? void 0 : _selectedSeatPreferen2.seatPreference) !== null && _selectedSeatPreferen !== void 0 ? _selectedSeatPreferen : null;
  const priceValue = (_price$price$value = price === null || price === void 0 || (_price$price = price.price) === null || _price$price === void 0 ? void 0 : _price$price.value) !== null && _price$price$value !== void 0 ? _price$price$value : 0;
  const priceMarkup = (_price$markup$value = price === null || price === void 0 || (_price$markup = price.markup) === null || _price$markup === void 0 ? void 0 : _price$markup.value) !== null && _price$markup$value !== void 0 ? _price$markup$value : price === null || price === void 0 ? void 0 : price.markup;
  const seatPreferences = value => ({
    price: value !== SEATING_PREFERENCE_VALUES.NO_OPTION ? priceValue : 0,
    markup: priceMarkup,
    seatPreference: value
  });
  const onChangeHandler = (_event, value) => {
    const segment = seatPreferences(value);
    onChange(activeSegment, activeTraveler, segment.price, segment.markup, segment.seatPreference);
  };
  const getPrice = value => value && value !== SEATING_PREFERENCE_VALUES.NO_OPTION ? priceValue : 0;
  const seatingPreferenceType = type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE ? 'SeatingBeside' : 'SeatingLight';
  const title = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Title`);
  const content = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Content`);
  const getIcons = () => {
    const defaultIcons = [[{
      id: 'c_flat-seat-selected-blue',
      size: '32px'
    }], [{
      id: 'c_flat-seat-selected-blue',
      size: '32px'
    }]];
    const aisleAndWindowIcons = [{
      id: 'c_flat-seat-preference',
      height: '18px',
      width: '12px',
      top: '4px'
    }];
    if (type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE) {
      return defaultIcons;
    }
    return [...defaultIcons, aisleAndWindowIcons];
  };
  return /*#__PURE__*/_jsxs(RadioGroup, {
    "data-testid": `seatMap-seatingCombo-${type}`,
    name: `${activeSegment}.traveler0.seatPreference`,
    onChange: event => onChangeHandler(event, event === null || event === void 0 ? void 0 : event.target.value),
    selectedValue: selectedPreference,
    children: [/*#__PURE__*/_jsxs(RadioGroup.Legend, {
      className: screenReaderOnly,
      children: [title, content]
    }), /*#__PURE__*/_jsx(SegmentPanel, {
      content: content,
      icons: getIcons(),
      title: title,
      children: options.map(_ref2 => {
        let {
          label,
          value,
          id
        } = _ref2;
        return /*#__PURE__*/_jsxs(Radio.Label, {
          className: cx('radio_option', radioStyles),
          htmlFor: id,
          children: [/*#__PURE__*/_jsx(Radio, {
            "data-testid": `seating-combo-${id}`,
            id: id,
            tabIndex: 0,
            value: value
          }), /*#__PURE__*/_jsx("span", {
            className: labelStyles,
            children: t(label)
          }), /*#__PURE__*/_jsx("span", {
            className: priceStyles,
            children: priceUtils.formatPrice(getPrice(value))
          })]
        }, id);
      })
    })]
  });
};
export default SeatingLightOrBeside;
//# sourceMappingURL=SeatingLightOrBeside.js.map